import React from 'react'
import "./Terms.css";




import { Helmet } from "react-helmet";


function Courses(props) {

  return (
    <>
      <div className={`et_pb_section et_pb_section_0 et_pb_with_background et_section_regular`}>
        <div className="et_pb_row et_pb_row_0">
          <div className="et_pb_column et_pb_column_4_4 et_pb_column_0  et_pb_css_mix_blend_mode_passthrough et-last-child">
            <div className="et_pb_module et_pb_text et_pb_text_0  et_pb_text_align_left et_pb_bg_layout_light">
              <div className="et_pb_text_inner"><h1 className="title white-txt">Terms and Conditions</h1></div>
            </div>
          </div>
        </div>
      </div>
      <div className="courses-container">
        <Helmet>
          <title>Terms & Conditions | Backstage Pass Institute of Gaming
          </title>
          <meta  name="description" content="Review the terms and conditions for using the Backstage Pass website and services. Understand your rights and responsibilities as a user." />
          <link rel="canonical" href="https://www.backstagepass.co.in/terms-and-conditions/" />

        </Helmet>

        <div className="courses-wrapper">
          <h3 className="mainHeadingTotall-2" style={{ textAlign: "left" }}>Terms and Conditions
          </h3>

          <p className='suprtst'>The User of the web-site (hereinafter referred to as "User") must carefully read and agree to the following terms and conditions, including any future amendments (hereinafter collectively referred to as the "Terms & Conditions") before using the Backstage Pass Institute of Gaming and Technology Website <a href="/" rel="noopener noreferrer" style={{ color: "#ec1925" }}>(www.backstagepass.co.in)</a>. Any user entering this Website agrees to follow and is bound to the following terms and conditions.
          </p>

        </div>
        <div className="courses-wrapper">
          <h3 className="mainHeadingTotall-2" style={{ textAlign: "left" }} >Use of Website Content
          </h3>

          <p className='suprtst'>The purpose of providing the content on Backstage Pass website is to inform the users about the Institute and the educational services offered by the Institute. The Website provides information regarding the different areas of the Institute’s educational services, including the events happening in the Institute, news updates about the Institute and achievements of the students. All content provided in the Website, including text, images, animations, videos, digital artworks, audio files and so on are intended for personal use and for information purpose only. They are not intended for commercial use. Thus the content may not be duplicated, sold, stored, distributed, printed, displayed, published, reproduced or exploited in any way for commercial use.
            Backstage Pass reserves all the rights to change, delete or add any content in the Website, without any prior notice to the users.

          </p>

        </div>
        <div className="courses-wrapper">
          <h3 className="mainHeadingTotall-2" style={{ textAlign: "left" }}>Modification of Terms and conditions of Service
          </h3>
          <p className='suprtst'>
            Backstage Pass may at any time modify the terms and conditions of the Services without any prior notification to you. You can access the latest version of the Terms, which shall be updated regularly at the Backstage Pass website. You accept to regularly review the Terms. You further agree and undertake that you are accessing the services available on this Site and transacting at your sole risk and are using your best and discreet judgment before entering into any transaction through this Site.
          </p>

          <p className='suprtst'>
            By submitting your details in the form of a query or feedback, you agree to become a member/user and receive newsletters and updates from Backstage Pass unless asked not to by writing to <a href="mailto:info@backstagepass.co.in" rel="noopener noreferrer" style={{ color: "#ec1925" }}>info@backstagepass.co.in</a>
          </p>


        </div>
        <div className="courses-wrapper">
          <h3 className="mainHeadingTotall-2" style={{ textAlign: "left" }}>Applicable Law
          </h3>
          <p className='suprtst'>
            This site is created and controlled by Backstage Pass at Hyderabad, India, therefore the laws of India shall apply; courts in Hyderabad shall have jurisdiction in respect to all the terms & conditions and privacy policy. Backstage Pass reserves the right to make changes to the site, Terms and Conditions and privacy policy.
          </p>

          <p className='suprtst'>
            The user of the website agrees not to use any obscene or offensive language, provide any false, misleading, abusive or harassing information and provide any personal information of someone else without their prior written consent. The user agrees to not use the site for any unlawful purpose. Backstage Pass reserves the right to take necessary action against any
          </p>
          <p className='suprtst'>
            individual/group/organization involved in any such malpractices, as per the court of law.
          </p>
        </div>
        <div className="courses-wrapper">
          <h3 className="mainHeadingTotall-2" style={{ textAlign: "left" }}>Use of Website
          </h3>
          <p className='suprtst'>
            Backstage Pass does not encourage the users of the website to use robots or any automated devices or programs to download, save, replicate, or distribute the content available in the Website.
          </p>

          <p className='suprtst'>
            Site users must take precautions to ensure that the process which they employ for accessing this Site does not expose them to the risk of viruses or other form of interference which may cause damage to their system. Backstage Pass shall not be responsible for any interference or damage caused to a user’s computer system that occurs in connection with the user’s access to this Website or any linked Website.
          </p>
          <p className='suprtst'>
            Backstage Pass shall not be responsible for any kind of damage that affects a user directly or indirectly caused by the use of or access of complete or part of any information given in this Website.
          </p>
        </div>
        <div className="courses-wrapper">
          <h3 className="mainHeadingTotall-2" style={{ textAlign: "left" }}>Form Registration
          </h3>
          <p className='suprtst'>
            When a user agrees to provide information in the enquiry form or any other form in the Backstage Pass website, then he/she agrees to: Make his/her contact information available to Backstage Pass.
          </p>

          <p className='suprtst'>
            Be contacted by Backstage Pass through telephonic calls, e-mails or SMS regarding any admission and education related information.
          </p>
          <p className='suprtst'>
            However, Backstage Pass reserves the right to make decisions on contacting a user.
          </p>
        </div>
      </div>

    </>
  )
}



export default Courses;

